module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as3007-d07c56387ea37cf89ae52a49587cf3e5.jpg";